import moment from 'moment';
import { Loader, NumpadPinEntry } from '../Widgets';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import { Employee, Session, Trip } from 'service';
import ArthaGateway from 'service/ArthaGateway';
import { RootState } from 'store/store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackward, faBarcode, faCircle, faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { BarcodeScanner, DetectedBarcode, useTorch } from 'react-barcode-scanner'
import 'react-barcode-scanner/polyfill'
import toast, { Toaster } from 'react-hot-toast';
import swal from 'sweetalert';
import Webcam from "react-webcam";

export const Attendance = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [employee, setEmployee] = useState<Employee>();
    const [employees, setEmployees] = useState<Employee[]>();
    const [gatepasses, setGatepasses] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isGatepassSaving, setIsGatepassSaving] = useState<boolean>(false);
    const [currentScreen, setCurrentScreen] = useState<string>("employee_list");
    const [captureVideo, setCaptureVideo] = useState(false);

    const webcamRef = useRef(null);

    useEffect(() => {
        if (employee) {
            getGatepasses();
        }
    }, [employee]);

    useEffect(() => {
        ArthaGateway
            .getEmployees(null, 5, 1, 100)
            .then((data) => {
                setEmployees(data.entries);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleVideoOnPlay = () => {
        setCaptureVideo(true);
    }

    const selectEmployee = (emp: Employee) => {
        setEmployee(emp);
        setCurrentScreen("employee_pin");
    }

    const getGatepasses = () => {
        ArthaGateway
            .getGatepass(employee?.id, "0")
            .then((data) => {
                setGatepasses(data.entries);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const punchAttendance = () => {
        if (gatepasses.length > 0) {
            let lastGatepassTime = moment(gatepasses[0].issuedAt);
            let currentTime = moment();
            let diff = currentTime.diff(lastGatepassTime, 'minutes');
            if (diff < 5) {
                toast('Please wait for 5 minute before punching again', { position: 'bottom-center', className: 'btn bg-danger' });
                return;
            }
        }

        let remarks: any = {};
        const imageSrc = (webcamRef.current as any).getScreenshot();
        remarks.imageSrc = imageSrc;

        let gatepass = {
            entryType: 'PIN',
            employeeId: employee?.id,
            issuedAt: moment().format("YYYY-MM-DDTHH:mm:ss"),
            remarks: JSON.stringify(remarks)
        };
        setIsGatepassSaving(true);
        ArthaGateway
            .postGatepass(gatepass)
            .then((data) => {
                setIsGatepassSaving(false);
                toast('Your punch information saved successfully', { position: 'bottom-center', className: 'btn bg-success' });
                setCurrentScreen("employee_list");
                setCaptureVideo(false);
            })
            .catch(error => {
                console.log(error);
                toast('Error saving the attendance, try again', { position: 'bottom-center', className: 'btn bg-danger' });
                setIsGatepassSaving(false);
            });
    }

    return (
        <div className="page-mark-attendance">
            <div className='container'>
                {isLoading &&
                    <Loader />
                }
                {!isLoading &&
                    <>
                        <div><Toaster /></div>
                        {currentScreen === "employee_list" &&
                            <div className='row'>
                                <div className='col-12'>
                                    <h2>Employees</h2>
                                    <ul className="list-group">
                                        {employees && employees.map((employee) => (
                                            <li className="list-group-item align-items-center" key={employee.id} onClick={() => selectEmployee(employee)}>
                                                <div className="float-start">
                                                    <div className="fw-bold">{employee.name}</div>
                                                    <div>{employee.groupName}</div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        }
                        {currentScreen === "employee_pin" &&
                            <div className='row'>
                                <div className='col-12 align-items-center d-flex flex-column' style={{ marginTop: "20px" }}>
                                    <h2>{employee?.name}</h2>
                                    <NumpadPinEntry
                                        onComplete={(pin) => {
                                            if (pin === employee?.pseudoName) {
                                                setCurrentScreen("punch_attendance");
                                                return true;
                                            }
                                            else {
                                                toast('Invalid PIN, Please enter correct PIN', { position: 'bottom-center', className: 'btn bg-danger' });
                                                return false;
                                            }
                                        }}
                                    />
                                    <div className="btn btn-danger mt-3 w-100" onClick={() => setCurrentScreen("employee_list")}>
                                        Back
                                    </div>
                                </div>
                            </div>
                        }
                        {currentScreen === "punch_attendance" &&
                            <>
                                <div className='row' style={{ marginTop: "10px" }}>
                                    <div style={{ width: "100%", margin: "20px 0", padding: 0, position: 'relative' }}>
                                        <>
                                            <Webcam ref={webcamRef} style={{ width: "100%", margin: "auto", maxWidth: "450px" }} onPlay={handleVideoOnPlay} />
                                        </>
                                    </div>
                                    {(captureVideo) &&
                                        <>
                                            {(gatepasses.length == 0 || (gatepasses.length > 0 && (gatepasses.length % 2) == 0)) &&
                                                <div className="btn btn-success w-100" onClick={punchAttendance}>
                                                    {isGatepassSaving &&
                                                        <div className="spinner-border text-light" role="status" style={{ height: "1.2rem", width: "1.2rem" }}>
                                                            <span className="sr-only">Saving...</span>
                                                        </div>
                                                    }
                                                    {!isGatepassSaving &&
                                                        <>Login</>
                                                    }
                                                </div>
                                            }
                                            {((gatepasses.length > 0 && (gatepasses.length % 2) == 1)) &&
                                                <div className="btn btn-danger w-100" onClick={punchAttendance}>
                                                    {isGatepassSaving &&
                                                        <div className="spinner-border text-light" role="status" style={{ height: "1.2rem", width: "1.2rem" }}>
                                                            <span className="sr-only">Saving...</span>
                                                        </div>
                                                    }
                                                    {!isGatepassSaving &&
                                                        <>Log Out</>
                                                    }
                                                </div>
                                            }    
                                        </>
                                    }
                                </div>
                                <div className='row' style={{ marginTop: "10px" }}>
                                    <ul className="list-group list-group-flush">
                                        {gatepasses && gatepasses.map((g) => (
                                            <li className="list-group-item">
                                                {moment(g.issuedAt).format("hh:mm a")}
                                                <div className={g.isLogin ? 'badge bg-success' : 'badge bg-danger'} style={{ float: "right" }}>
                                                    {g.isLogin ? "IN" : "OUT"}
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </>
                        }
                    </>
                }
            </div>
        </div>
    );
};